import type { TownNewsItem } from '../types/town-news.types';
export type NewsLanguage = 'ru' | 'en';
const actions: Record<string, [string, string]> = {
  introduce: ['представился встречному', 'introduced themselves to someone'],
  settle_debt: ['оплатил прежний долг', 'settled an earlier debt'],
  heal: ['помог раненому', 'helped an injured person'],
  paid_help: ['помог за плату', 'provided paid help'],
  rob: ['ограбил путника', 'robbed a traveler'],
  steal: ['совершил кражу', 'committed theft'],
  finish: ['добил беспомощного', 'killed a helpless person'],
  finish_all: ['расправился с беспомощными', 'killed helpless survivors'],
  heal_all: ['помог выжившим', 'helped the survivors'],
  rob_all: ['ограбил выживших', 'robbed the survivors'],
  donate_small: ['помог нуждающимся деньгами', 'gave money to people in need'],
  donate_large: ['щедро помог нуждающимся', 'generously helped people in need'],
  compensate: ['возместил чужую потерю', 'compensated a victim'],
  escort: ['сопроводил путника', 'escorted a traveler'],
  call_help: ['позвал помощь', 'called for help'],
  find_shelter: ['помог найти кров', 'helped find shelter'],
  protect: ['заступился за пострадавшего', 'intervened to protect a victim'],
  join_robbers: ['помог грабителям', 'helped robbers'],
  join_hooligans: ['присоединился к хулиганам', 'joined hooligans'],
  help_guards: ['вступился за стражу', 'helped the guards'],
  help_bandits: ['помог разбойникам в бою', 'helped bandits in battle'],
  support_guards: ['поддержал стражу', 'supported the guards'],
  capture: ['взял выжившего в плен', 'captured a survivor'],
  release: ['отпустил пленника', 'released a captive'],
  hand_over: ['передал разбойника страже', 'handed a bandit to the guards'],
  join_feast: ['участвовал в празднике в таверне', 'joined a tavern celebration'],
  treat_all: ['угостил посетителей таверны', 'treated tavern patrons'],
  sing: ['развеселил таверну песней', 'sang at the tavern'],
  spoil_feast: ['испортил праздник', 'disrupted a celebration'],
  start_brawl: ['устроил драку', 'started a brawl'],
  pay_bill: ['честно оплатил счёт', 'paid the bill'],
  leave_unpaid: ['ушёл из таверны без оплаты', 'left the tavern without paying'],
  deceive: ['обманул встречного', 'deceived someone'],
  mislead: ['указал семье ложный путь', 'misled a family'],
  honest_work: ['выполнил обещанную работу', 'completed promised work'],
};
export function townNewsText(item: TownNewsItem, language: NewsLanguage): string {
  const ru = language === 'ru';
  const name = item.hero?.name || (ru ? 'Неизвестный путник' : 'An unknown traveler');
  const verb = item.publicParams.action?.split(':')[0] ?? '';
  const phrase = actions[verb]?.[ru ? 0 : 1] ?? (ru ? 'стал участником события' : 'took part in an event');
  const outcome = item.publicParams.outcome ?? "";
  const failed = ['failure', 'failed', 'attempt_failed', 'route_death', 'died', 'hero_died'].includes(outcome);
  if (failed) {
    const attempts: Record<string, [string, string]> = {
      heal: ['пытался спасти раненого, но помощь не удалась', 'tried to save an injured person, but the help failed'],
      paid_help: ['пытался помочь за плату, но не смог', 'tried to provide paid help, but failed'],
      rob: ['пытался ограбить встречного, но не смог', 'attempted a robbery, but failed'],
      finish: ['пытался добить беспомощного, но не смог', 'tried to kill a helpless person, but failed'],
      escort: ['не смог безопасно довести путника', 'could not escort a traveler to safety'],
    };
    return `${name} ${attempts[verb]?.[ru ? 0 : 1] ?? (ru ? 'пытался действовать, но потерпел неудачу' : 'tried to act, but failed')}.`;
  }
  if (outcome === 'attempt_started' || outcome === 'battle_requested') {
    const begun = verb === 'escort' ? (ru ? 'отправился сопровождать путника' : 'set out to escort a traveler')
      : verb === 'honest_work' ? (ru ? 'взялся за обещанную работу' : 'started the promised work')
      : (ru ? 'начал действовать' : 'began to act');
    return `${name} ${begun}. ${ru ? 'Итог ещё неизвестен.' : 'The result is not yet known.'}`;
  }
  if(outcome==='observed_victory'||outcome==='observed_stalemate')return ru?'Свидетели сообщают об исходе боя. Герой в нём не участвовал.':'Witnesses report a battle outcome. The hero did not take part.';
if(verb==='battle_result')return ru?'Свидетели сообщают об исходе боя.':'Witnesses report a battle outcome.';
if(['left_without_help','left_without_intervention','left_without_action'].includes(outcome))return `${name} ${ru?'не стал вмешиваться':'did not intervene'}.`;
if(outcome==='surrendered_withdrawal')return `${name} ${ru?'сложил оружие и ушёл по соглашению':'surrendered and left by agreement'}.`;
if(outcome!=='success')return `${name} ${ru?'стал участником события; точный итог пока не подтверждён':'took part in an event; its exact outcome is not confirmed'}.`;
return `${name} ${phrase}.`;
}
